/**
 * @generated SignedSource<<74120ed5825ef8a4f3555b05e3916be2>>
 * @relayHash 985f6ee79c133e444ec409d517228f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871

import type { ConcreteRequest, Query } from 'relay-runtime';
export type WatchDialogComponentWithWatchChildrenQuery$variables = {
  contentId: string;
};
export type WatchDialogComponentWithWatchChildrenQuery$data = {
  readonly singleContent: {
    readonly __typename: "Content";
    readonly currentUserHasAncestorWatchingChildren: boolean | null | undefined;
    readonly currentUserIsWatching: boolean;
    readonly currentUserIsWatchingChildren: boolean | null | undefined;
    readonly id: string | null | undefined;
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
        readonly isWatchingBlogs: boolean;
      };
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type WatchDialogComponentWithWatchChildrenQuery = {
  response: WatchDialogComponentWithWatchChildrenQuery$data;
  variables: WatchDialogComponentWithWatchChildrenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserHasAncestorWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              },
              {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
              }
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchDialogComponentWithWatchChildrenQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchDialogComponentWithWatchChildrenQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "985f6ee79c133e444ec409d517228f1d",
    "id": "6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871",
    "metadata": {},
    "name": "WatchDialogComponentWithWatchChildrenQuery",
    "operationKind": "query",
    "text": "query WatchDialogComponentWithWatchChildrenQuery($contentId:ID!){singleContent(id:$contentId){__typename,id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "b5ae30f67304ac91f4e47cad0c3cbfda";

export default node;
